var diff = require('deep-diff').diff;
var _ = require('underscore');

import {
    MAJ_USER_SELECTED,
    REMOVE_USER_SELECTED,
    ADD_TO_ALL_USERS_SELECTED,
    REMOVE_FROM_ALL_USERS_SELECTED,
    REINIT_ALL_USERS_SELECTED
} from '../mutations-type'

// initial state
const state = {
    userSelected: null,
    showModalLinkMember: false,
    allUsersSelected: []
}

// mutations
const mutations = {
    [MAJ_USER_SELECTED] (state, user) {
        state.userSelected = user
    },
    [REMOVE_USER_SELECTED] (state) {
        state.userSelected = null
    },
    [ADD_TO_ALL_USERS_SELECTED] (state, info) {
        if (!_.contains(state.allUsersSelected, {membre: info.user, role: info.role}))
            state.allUsersSelected.push({membre: info.user, role: info.role})
    },
    [REMOVE_FROM_ALL_USERS_SELECTED] (state, info) {
        var index = _.findIndex(state.allUsersSelected, {membre: info.user, role: info.role})
        if (index >= 0)
            state.allUsersSelected.splice(index, 1)
    },
    [REINIT_ALL_USERS_SELECTED] (state) {
        state.allUsersSelected=[];
    }
}

const actions = {
    majUserSelected({commit}, user) {
        commit(MAJ_USER_SELECTED, user)
    },
    removeUserSelected({commit},) {
        commit(REMOVE_USER_SELECTED)
    },
    addToAllUserSelected({commit}, info) {
        // console.log(MAJ_USER_SELECTED+": "+user);
        commit(ADD_TO_ALL_USERS_SELECTED, info)
    },
    removeFromAllUsersSelected({commit}, role, user) {
        commit(REMOVE_FROM_ALL_USERS_SELECTED, role, user)
    },
    reinitAllUsersSelected({commit},) {
        commit(REINIT_ALL_USERS_SELECTED)
    },
}

const getters = {
    getUserSelected : state => {
        return state.userSelected;
    },
    getAllUsersSelected : state => {
        return _.groupBy(state.allUsersSelected, function (item) {
            return item.role.role
        })
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/vuex/modules/searchMember.js